import React from 'react';

const About = () => {
  return (
    <div className='container'>
      <h1>About Us</h1>
      <p>Welcome to SnapByte - Your Gateway to the World of Blogging!</p>

      <h2>Our Mission</h2>
      <p>
        At SnapByte, we believe that every voice deserves to be heard, and every story deserves to be shared. We are a passionate team of creators, developers, and dreamers who have come together to build a platform that empowers individuals and businesses to express themselves, connect with their audience, and make an impact in the digital world.
      </p>

      <h2>Our Story</h2>
      <p>
        SnapByte was born out of a shared passion for storytelling and technology. Our founder, [Founder's Name], had a vision of creating a platform that would revolutionize the way people share their stories and ideas online. With a small team of dedicated individuals, we embarked on this journey, and today, SnapByte is the result of our collective hard work and dedication.
      </p>

      <h2>What Sets Us Apart</h2>
      <ul>
        <li>
          <strong>User-Friendly Interface:</strong> We understand that not everyone is a tech genius. That's why we've designed SnapByte with simplicity in mind. Our user-friendly interface makes it easy for anyone to create and manage a blog.
        </li>
        <li>
          <strong>Customization:</strong> We believe that your blog should reflect your unique style. With SnapByte, you can customize your blog to match your personality or brand. Choose from a wide range of themes and design options to make it truly yours.
        </li>
        <li>
          <strong>Powerful Features:</strong> Behind the simplicity, there's power. SnapByte offers a robust set of features, including rich text editing, multimedia integration, SEO tools, and analytics, to help you grow your audience and enhance your online presence.
        </li>
        <li>
          <strong>Community:</strong> Blogging is not just about writing; it's about connecting with others who share your interests. SnapByte fosters a vibrant and supportive community of bloggers, where you can learn, collaborate, and grow together.
        </li>
      </ul>

      <h2>Meet the Team</h2>
      <p>
        We are a diverse team of individuals with a shared passion for blogging and technology. Each member brings a unique set of skills and experiences to the table, but we all share a common goal: to make SnapByte the best blogging platform out there.
      </p>
      <ul>
        <li>Muhammad Ahmed - Founder & CEO</li>
        <li>Dr.Azam Sheikh - Lead Data Scientist</li>
        <li>Muhammad Wajid - Chief Technology Officer</li>
        <li>Muhammad Hammad - Chief Content Officer</li>
        <li>Muhammad Usman - Design Guru</li>
      </ul>
    </div>
  );
};

export default About;
  